__turbopack_context__.v({
  "grid": "CompilationGrid-module-sass-module__1LtGxq__grid",
  "item": "CompilationGrid-module-sass-module__1LtGxq__item",
  "selections-header": "CompilationGrid-module-sass-module__1LtGxq__selections-header",
  "selections-wrap": "CompilationGrid-module-sass-module__1LtGxq__selections-wrap",
});
